<script>
// fix mds popover position issue when it located in scrollable containers.
import MdsPopover from '@mds/popover';

export default {
  extends: MdsPopover,
  mounted() {
    if (this.triggerElement) {
      this.scrollListener = this.debounce(this.updateVisiblePopoverPosition, 16);
      this.scrollContainer = this.getScrollableParent(this.triggerElement);
      this.scrollContainer.addEventListener('scroll', this.scrollListener, { passive: true });
    }
  },
  beforeDestroy() {
    if (this.triggerElement) {
      this.scrollContainer.removeEventListener('scroll', this.scrollListener);
    }
  },
  methods: {
    getScrollableParent(ele) {
      if (!ele || ele === document.body) {
        return document.body;
      }
      return this.isScrollable(ele) ? ele : this.getScrollableParent(ele.parentNode);
    },
    isScrollable(ele) {
      const hasScrollContent = ele.scrollHeight >= ele.clientHeight;
      const overfowYStyle = window.getComputedStyle(ele).overflowY;
      const isScrollable = !(overfowYStyle.includes('hidden') || overfowYStyle.includes('visible'));
      return hasScrollContent && isScrollable;
    },
    updateVisiblePopoverPosition() {
      if (!this.isVisible) return;
      this.updatePosition();
    },
  },
};
</script>
